import { Injectable } from '@angular/core';
import { ConnectionService } from '../connection/connection.service';
import { AppConstants } from '../../entity/constants';
import { UpdateState, UpdateTaskType } from '../../models/update-state';
import { TaskMovementService } from '../operations/task-movement.service';
import { DataRepositoryService } from '../data-repository/data-repository.service';
import { MessageService } from 'primeng/api';
import { ErrorMessage, ErrorType } from '../../entity/error.const';
import { HttpStatusCode } from '@angular/common/http';
import { take } from 'rxjs';
import { CommandType } from '../../entity/enums';

@Injectable({
  providedIn: 'root'
})

export class StateUpdateService {
  showStatePopup : boolean = false;
  constructor(
    private readonly connectionService: ConnectionService,
    private taskMovementService: TaskMovementService,
    private readonly dataRepositoryService: DataRepositoryService,
    private readonly messageService: MessageService
  ) { }

  /**
   * 
   * @param tasks 
   */
  updateState(tasks:UpdateState[] | UpdateTaskType[]) {
    return this.syncStateWithServer(tasks)
  }

  /**
   * 
   * @param payload 
   * @returns 
   */
  syncStateWithServer(payload: UpdateState[] | UpdateTaskType[]) {
    return this.connectionService.httpReq({
      reqType: AppConstants.POSTREQUEST,
      endUrl: AppConstants.Command,
      directoryType: AppConstants.DP,
      data: payload
    });
  }

  /**
   * Create payload to update task type for command API 
   * @param taskType - task type to be updated Deliver | HandOver
   * @param taskId - task to be updated
   * @returns 
   */
  getPayload(taskType: string, taskId: string) {
    const payload: UpdateTaskType[] = [{
      id: crypto.randomUUID(),
      command_type: CommandType.ChangeTaskType,
      task_type: taskType,
      timestamp: new Date(),
      task_id: taskId,
      bl_id: this.dataRepositoryService.selectedBusinessLocation,
      user_id: this.dataRepositoryService.loggedInUser?.username ?? "",
    }];
    return payload;
  }
  
  /**
   * after task type update, delta call for updating task table.
   */
  handleUpdateStateSuccess($event: boolean) {
    this.taskMovementService.updateWithDeltaPostTaskMovement();
  }

  /**
   * update task type Deliver | Handover
   * @param event - updated task type
   * @param taskId - task to be updated
   */
  handleTaskTypeUpdate(event: { state: string; reason: string;}, taskId: string) {
    const payload: UpdateTaskType[] = this.getPayload(event.state, taskId);
    this.updateState(payload).pipe(take(1)).subscribe({
      next: () => {
        this.showStatePopup = false;
        this.messageService.add({ severity: ErrorType.SUCCESS, closable: false, summary: '', detail: ErrorMessage.STATEUPDATEMESSAGE });
        this.handleUpdateStateSuccess(true);
      },
      error: (error) => {
        if (error.status === HttpStatusCode.Forbidden) {
          this.messageService.add({ severity: ErrorType.ERROR, closable: false, summary: '', detail: ErrorMessage.RESTRICTIONMESSAGE });
        } else {
          this.messageService.add({ severity: ErrorType.ERROR, closable: false, summary: '', detail: ErrorMessage.STATEUPDATEERRORMESSAGE });
        }
      }
    });
  }
}
